import React, { useState } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { Redirect } from 'react-router'
import { push } from 'connected-react-router'
import { ModalOrder } from '../components/ModalOrder'

import{ Button} from '../components'

import OrderOptions from './OrderOptions'


import { objectToArray, arrayToObject } from '../helper'

import * as actions from '../actions' 

import {
    RangeSelector
} from '../components'

export function OrderInvoiceInfoComponent(props) {
    if (props.loading)
        return null

    const invoiceInfo = props.invoiceInfo || {}
    const [show,setShow]=useState(true);
    const close=()=> setShow(false);
    return <article className={"shop-page page"}>
        <form onSubmit={(e) => {
            e.preventDefault()
            props.next()
        }}>
            <section className="section gray-section on-screen">
                <div className="section-content">
                    <div className="container">
                        <div>
                            {show ? <div className="back-drop"></div> :null}
                        </div>
                        <h1 className="text-center shop-title">Rechnungs&shy;informationen</h1>
                    <div className="shop">
                    <div className="shop-content">
                        <div className="label-grid label-grid--small">
                            <span className="label-text">Anrede*</span>
                            <div className="label-control">
                                <label className="radio">
                                    <input className="radio-input" type="radio" required name="salutation" value="mrs" checked={invoiceInfo.salutation==='mrs'} onChange={props.handleChange} />
                                    Frau
                                </label>
                                <label className="radio">
                                    <input className="radio-input" type="radio" required name="salutation" value="mr" checked={invoiceInfo.salutation==='mr'} onChange={props.handleChange} />
                                    Herr
                                </label>
                            </div>
                        </div>
                        <label className="label-grid label-grid--small">
                            <span className="label-text">Firma</span>
                            <div className="label-control">
                                <input className="input" type="text" name="company" value={invoiceInfo.company} onChange={props.handleChange} />
                            </div>
                        </label>
                        <label className="label-grid label-grid--small">
                            <span className="label-text">Vorname*</span>
                            <div className="label-control">
                                <input className="input" type="text" required name="firstName" value={invoiceInfo.firstName} onChange={props.handleChange} />
                            </div>
                        </label>
                        <label className="label-grid label-grid--small">
                            <span className="label-text">Nachname*</span>
                            <div className="label-control">
                                <input className="input" type="text" required name="lastName" value={invoiceInfo.lastName} onChange={props.handleChange} />
                            </div>
                        </label>
                        <label className="label-grid label-grid--small">
                            <span className="label-text">Straße*</span>
                            <div className="label-control">
                                <input className="input" type="text" required name="street" value={invoiceInfo.street} onChange={props.handleChange} />
                            </div>
                        </label>
                        <label className="label-grid label-grid--small">
                            <span className="label-text">PLZ*</span>
                            <div className="label-control">
                                <input className="input" type="text" required name="zipCode" value={invoiceInfo.zipCode} onChange={props.handleChange} />
                            </div>
                        </label>
                        <label className="label-grid label-grid--small">
                            <span className="label-text">Stadt*</span>
                            <div className="label-control">
                                <input className="input" type="text" required name="city" value={invoiceInfo.city} onChange={props.handleChange} />
                            </div>
                        </label>
                        <label className="label-grid label-grid--small">
                            <span className="label-text">Telefon</span>
                            <div className="label-control">
                                <input className="input" type="tel" name="phone" value={invoiceInfo.phone} onChange={props.handleChange} />
                            </div>
                        </label>
                        <label className="label-grid label-grid--small">
                            <span className="label-text">E-Mail*</span>
                            <div className="label-control">
                                <input className="input" type="email" required name="email" value={invoiceInfo.email} onChange={props.handleChange} />
                            </div>
                        </label>
                        <p className="red">* Pflichtfelder</p>
                    </div>
                    <div className="shop-sidebar">
                        <OrderOptions {...props} prev={props.prev} nextType="submit" next={undefined} />
                    </div>
                </div>
                </div>   
                </div>
            </section>   
        </form>
    </article>
}

const OrderInvoiceInfo = connect(
    (state, props) => {
        const training = state.order.trainingId 
            && arrayToObject(state.shop.trainings , 'id')[state.order.trainingId]

        console.log(state)

        return {
            isVoucher: state.order.type == "voucher",
            loading: state.shop.loading,
            participants: state.order.participants,
            training: training,
            voucherText: state.order.voucherText,
            voucherAmount: state.order.voucherAmount,
            voucherName: state.order.voucherName,
            trainingType: training && state.shop.trainingTypes[training.trainingTypeId],
            invoiceInfo: state.order.invoiceInfo
        }
    },
    (dispatch, props) => {
        const myProps = props

        return {
            handleChange: (event) => {
                const target = event.target
                const value = target.type === 'checkbox' ? target.checked : target.value
                const name = target.name

                dispatch({type: 'ORDER_INVOICE_INFO_CHANGED', name, value }) 
            },
            prev: () => {
                dispatch(actions.invoiceInfoPrev())
            },
            next: () => {
                dispatch(actions.invoiceInfoNext())
            },

            onParticipantCountChanged: (participantCount) => { 
                dispatch({type: 'ORDER_PARTICIPANT_COUNT_CHANGED', participantCount }) 
            }
        }
    }
)(OrderInvoiceInfoComponent)

export default OrderInvoiceInfo


// WEBPACK FOOTER //
// ./src/pages/OrderInvoiceInfo.jsx